var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "company-profiles-list" } },
    [
      _c("portal", { attrs: { to: "content-header" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "ci-collapsible-header",
                rawName: "v-ci-collapsible-header",
              },
            ],
            key: "companies-index-header",
            staticClass: "ci-content-header sticky",
            attrs: { id: "companies-index-header" },
          },
          [
            _c(
              "div",
              { staticClass: "ci-content-header__inner pb-0" },
              [
                _c("h1", {
                  staticClass: "h2 header-title",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.views.company_profiles.index.title")
                    ),
                  },
                }),
                _c("p", { staticClass: "mb-4 header-subtitle" }, [
                  _vm._v(
                    _vm._s(_vm.$t("ui.views.company_profiles.index.subtitle"))
                  ),
                ]),
                _c(
                  "b-tabs",
                  {
                    staticClass: "ci-tabs no-border",
                    attrs: {
                      id: "companies-list-header-tabs",
                      replaceUrl: false,
                    },
                    model: {
                      value: _vm.currentTab,
                      callback: function ($$v) {
                        _vm.currentTab = $$v
                      },
                      expression: "currentTab",
                    },
                  },
                  [
                    _c("b-tab", {
                      attrs: {
                        id: "asset_managers",
                        title: _vm.$t(
                          "ui.views.company_profiles.index.asset_managers"
                        ),
                        active: _vm.type == "asset_manager",
                      },
                      on: {
                        click: function ($event) {
                          _vm.companyType = "asset_manager"
                        },
                      },
                    }),
                    _c("b-tab", {
                      attrs: {
                        id: "wealth_managers",
                        title: _vm.$t(
                          "ui.views.company_profiles.index.wealth_managers"
                        ),
                        active: _vm.type == "wealth_manager",
                      },
                      on: {
                        click: function ($event) {
                          _vm.companyType = "wealth_manager"
                        },
                      },
                    }),
                    _c("b-tab", {
                      attrs: {
                        id: "financial_service_provider",
                        title: _vm.$t(
                          "ui.views.company_profiles.index.financial_service_providers"
                        ),
                        active: _vm.type == "financial_service_provider",
                      },
                      on: {
                        click: function ($event) {
                          _vm.companyType = "financial_service_provider"
                        },
                      },
                    }),
                    _c("b-tab", {
                      attrs: {
                        id: "community_partners",
                        title: _vm.$t(
                          "ui.views.company_profiles.index.community_partners"
                        ),
                        active: _vm.type == "community_partner",
                      },
                      on: {
                        click: function ($event) {
                          _vm.companyType = "community_partner"
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "b-tabs",
        {
          staticClass: "ci-tabs no-border",
          attrs: {
            id: "companies-list-content-tabs",
            replaceUrl: false,
            "nav-wrapper-class": "d-none",
          },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "b-tab",
            {
              attrs: {
                title: _vm.$t("ui.views.company_profiles.index.asset_managers"),
                active: _vm.type == "asset_manager",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "ci-content-padding-as-body-x ci-content-padding-as-body-b",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row no-gutters-handheld with-gutter-bottom",
                    },
                    [
                      _vm._l(_vm.profiles.asset_manager, function (company) {
                        return [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 d-flex" },
                            [
                              _c("ci-company-tile", {
                                key: company.id,
                                attrs: {
                                  company: company,
                                  "padding-class":
                                    "ci-content-padding with-hover w-100",
                                  "show-counts": true,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-tab",
            {
              attrs: {
                title: _vm.$t(
                  "ui.views.company_profiles.index.wealth_managers"
                ),
                active: _vm.type == "wealth_manager",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "ci-content-padding-as-body-x ci-content-padding-as-body-b",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row no-gutters-handheld with-gutter-bottom",
                    },
                    [
                      _vm._l(_vm.profiles.wealth_manager, function (company) {
                        return [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 d-flex" },
                            [
                              _c("ci-company-tile", {
                                key: company.id,
                                attrs: {
                                  company: company,
                                  "padding-class":
                                    "ci-content-padding with-hover w-100",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-tab",
            {
              attrs: {
                title: _vm.$t(
                  "ui.views.company_profiles.index.financial_service_providers"
                ),
                active: _vm.type == "financial_service_provider",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "ci-content-padding-as-body-x ci-content-padding-as-body-b",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row no-gutters-handheld with-gutter-bottom",
                    },
                    [
                      _vm._l(
                        _vm.profiles.financial_service_provider,
                        function (company) {
                          return [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-6 d-flex" },
                              [
                                _c("ci-company-tile", {
                                  key: company.id,
                                  attrs: {
                                    company: company,
                                    "padding-class":
                                      "ci-content-padding with-hover w-100",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-tab",
            {
              attrs: {
                title: _vm.$t(
                  "ui.views.company_profiles.index.community_partners"
                ),
                active: _vm.type == "community_partner",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "ci-content-padding-as-body-x ci-content-padding-as-body-b",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row no-gutters-handheld with-gutter-bottom",
                    },
                    [
                      _vm._l(
                        _vm.profiles.community_partner,
                        function (company) {
                          return [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-6 d-flex" },
                              [
                                _c("ci-company-tile", {
                                  key: company.id,
                                  attrs: {
                                    company: company,
                                    "padding-class":
                                      "ci-content-padding with-hover w-100",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }